var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.w, height: _vm.h }),on:{"touchmove":function($event){$event.preventDefault();}}},[_c('canvas',{staticClass:"canvas",attrs:{"id":_vm.state.uid,"data-uid":_vm.state.uid,"disabled":_vm.state.disabled}})])}
var staticRenderFns = []

export { render, staticRenderFns }